<script setup lang="ts">
import { computed, ref } from 'vue'
import type { SurveyStep } from '@/types/surveyTypes'
import StepperItemQuestion from './StepperItemQuestion.vue'
import { Form } from 'vee-validate'
import { useSurvey } from '@/composables/onlineSurvey/useSurvey'
import { useI18n } from '@/i18n'

const {
  currentStep,
  stepHistory,
  goToPreviousStep,
  createStepValidationSchema,
  getCurrentStepAnswers,
  goToNextVisibleStep,
  answers,
} = useSurvey()
const formRef = ref()

const props = defineProps<{
  step: SurveyStep
}>()

//emit event when survey is completed
const emit = defineEmits<{
  (e: 'surveryCompleted', stepIndex: number): void
  (e: 'moveSteps'): void
}>()

const validationSchema = computed(() => {
  answers.value
  return createStepValidationSchema(currentStep.value)
})

const initialValues = computed(() => {
  answers.value
  return getCurrentStepAnswers()
})

const handleSubmit = async () => {
  if (!formRef.value) return

  const { valid } = await formRef.value.validate()
  console.log(valid)
  if (valid) {
    moveStep(1)
  }
}

function moveStep(direction: number) {
  console.log('Moving step:', direction)

  if (direction === -1) {
    // Verwende die neue Historie-basierte Navigation
    goToPreviousStep()
    emit('moveSteps')
  } else {
    // Verwende goToNextVisibleStep für Vorwärts-Navigation
    const isFinished = goToNextVisibleStep()
    emit('moveSteps')
    if (isFinished) {
      //FORM FINISHED
      emit('surveryCompleted', currentStep.value)
    }
  }
}

const backwardDisabled = computed(() => {
  return stepHistory.value.length <= 1
})

const { t } = useI18n()

const handleAutoAdvance = () => {
  // Nur automatisch weiterleiten, wenn es die einzige Frage im Step ist
  if (props.step.questions.length === 1) {
    setTimeout(() => {
      handleSubmit()
    }, 400)
  }
}
</script>
<template>
  <div class="stepper-item has-text-centered">
    <Form
      ref="formRef"
      :validation-schema="validationSchema"
      :initial-values="initialValues"
      @submit="handleSubmit"
      v-slot="{ isSubmitting }"
    >
      <p class="is-size-5 is-uppercase has-text-weight-semibold mb-1">{{ props.step.title }}</p>
      <div v-for="question in props.step.questions" :key="question.id">
        <StepperItemQuestion :question="question" @answerSelected="handleAutoAdvance" />
      </div>

      <div class="is-flex is-justify-content-space-between mt-2">
        <button
          type="button"
          class="button is-light"
          @click="moveStep(-1)"
          :disabled="backwardDisabled"
        >
          {{ t('back') }}
        </button>
        <button type="submit" class="button is-primary" :class="{ 'is-loading': isSubmitting }">
          {{ t('next') }}
        </button>
      </div>
    </Form>
  </div>
</template>
